export default {
    name: 'MyFreeCams',
    tagline: '#1 Adult Webcam Community',
}
